import { useIsMutating } from 'react-query';
import { DoctorMutationKey } from 'config/doctorMutationKey';

export const useIsAnyAssignExaminationMutating = () =>
  useIsMutating([DoctorMutationKey.AssignExaminations]);
